import AutoCompleteVendor from "components/common/AutoCompleteVendor";
import PriceSelect from "components/common/PriceSelect";
import ProductSelect from "components/common/ProductSelect";
import QuoteCostGroup from "interfaces/QuoteCostGroup";
import QuoteProduct from "interfaces/QuoteProduct";
import QuoteSalesOrder from "interfaces/QuoteSalesOrder";
import Vendor from "interfaces/Vendor";
import * as numeral from "numeral";
import * as React from "react";
import { Option } from "react-select";
import MaskedInput from "react-text-mask";
import createNumberMask from "utils/createNumberMask";
import "./Step3.css";

interface Props {
    onSubmit: Function;
    onCancel: Function;
    vendors: Vendor[];
    data: QuoteSalesOrder;
}

interface State {
    costGroups: QuoteCostGroup<EditableQuoteProduct>[];
    subTotal: number;
    salesTax: number;
    grandTotal: number;
    selectedVendorNo?: string;
    selectedVendorName?: string;
    vendorId?: number;
    data: QuoteSalesOrder;
    subTotalCost: number;
    hasAllCosts: boolean;
}

interface EditableQuoteProduct extends QuoteProduct {
    isEditing: boolean;
}

export default class SalesOrderStep3 extends React.Component<Props, State> {
    private categoryNameInputs: HTMLTextAreaElement[];

    public constructor(props: Props) {
        super(props);

        this.state = {
            costGroups: [],
            subTotal: 0,
            salesTax: 0,
            grandTotal: 0,
            selectedVendorNo: "",
            selectedVendorName: "",
            vendorId: 0,
            data: this.props.data,
            subTotalCost: 0,
            hasAllCosts: false,
        };

        this.categoryNameInputs = [];

        this.handleHeaderNameChanged = this.handleHeaderNameChanged.bind(this);
        this.handleAddCategoryClicked = this.handleAddCategoryClicked.bind(this);
        this.handleAddCost = this.handleAddCost.bind(this);
        this.handleEditCostClicked = this.handleEditCostClicked.bind(this);
        this.handleRemoveCost = this.handleRemoveCost.bind(this);
        this.handleRemoveHeader = this.handleRemoveHeader.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSubmitAsDraft = this.handleSubmitAsDraft.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleDragEnd = this.handleDragEnd.bind(this);

        this.doNothing = this.doNothing.bind(this);
        this.handleVendorSelected = this.handleVendorSelected.bind(this);
    }

    public render() {
        return (
            <div>
                <div className="tab-bar mb-4 pb-3">
                    <p className="tab-bar__step-info text-right">Step 2 of 2</p>
                    <ul className="tab-bar__list">
                        <li>
                            <a href="#" onClick={(event) => this.handleSubmit(event, 1)}>
                                Sales Order Details
                            </a>
                        </li>

                        <li>
                            <a
                                href="#"
                                onClick={(event) => this.handleSubmitPrevious(event, 2)}
                            >
                                Material Details
                            </a>
                        </li>
                        <li className="active">
                            <a href="#" onClick={(event) => this.handleSubmit(event, 3)}>
                                Vendor Details
                            </a>
                        </li>
                    </ul>
                </div>
                <div className="box-wrap">
                    <form autoComplete="off">
                        <h2 className="card__title">Vendor Details</h2>
                        <div className="box">
                            <div className="row">
                                <div className="field-group col-sm-12 d-flex">
                                    <div className="field-label">Choose Vendor</div>
                                    <div
                                        style={{
                                            position: "relative",
                                            width: "100%",
                                        }}
                                    >
                                        <AutoCompleteVendor
                                            name="vendor list"
                                            onChange={this.handleVendorSelected}
                                            value={this.state.selectedVendorName || ""}
                                            onClick={(e) => {
                                                if (!!e.currentTarget.innerText) {
                                                    let dataset: any = this.props.vendors.find(
                                                        (vendor) =>
                                                            vendor.name.trim().toLowerCase() ===
                                                            e.currentTarget.innerText.trim().toLowerCase()
                                                    );

                                                    if (dataset !== undefined) {
                                                        this.setState({
                                                            vendorId: Number(dataset.id),
                                                            selectedVendorNo: dataset.vendorNo,
                                                            selectedVendorName: dataset.name,
                                                        });
                                                    }
                                                }
                                            }}
                                            suggestions={
                                                this.props.vendors
                                                    ? this.props.vendors.reduce(
                                                        (acc: any, current: Vendor) => {
                                                            acc.push({ id: current.id, name: current.name });
                                                            return acc;
                                                        },
                                                        []
                                                    )
                                                    : []
                                            }
                                        />
                                    </div>
                                </div>

                                <div className="field-group col-sm-6" id="triggerSelectVendor">
                                    <span className="field-label">Vendor Number</span>
                                    <span className="field-item">
                                        {this.state.selectedVendorNo}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>

                <div className="card card--form">
                    <div className="card-block">
                        <form name="form" className="form">
                            <h2 className="card__title">Cost Details</h2>
                            {this.state.costGroups
                                .reduce((acc: any, current: any) => {
                                    acc.push({
                                        ...current,
                                        products: current.products.reduce(
                                            (productAcc: any, productCurrent: any) => {
                                                if (productCurrent.checked) {
                                                    productAcc.push({
                                                        ...productCurrent,
                                                    });
                                                }
                                                return productAcc;
                                            },
                                            []
                                        ),
                                        subTotal: current.products
                                            .reduce((productAcc: any, productCurrent: any) => {
                                                if (productCurrent.checked) {
                                                    productAcc.push({
                                                        ...productCurrent,
                                                    });
                                                }
                                                return productAcc;
                                            }, [])
                                            .reduce(
                                                (productAcc: any, productCurrent: any) =>
                                                    `${parseFloat(productCurrent.amount) +
                                                    parseFloat(productAcc)
                                                    }`,
                                                0
                                            ),
                                        subTotalCost: current.products
                                            .reduce((productAcc: any, productCurrent: any) => {
                                                if (productCurrent.checked) {
                                                    productAcc.push({
                                                        ...productCurrent,
                                                    });
                                                }
                                                return productAcc;
                                            }, [])
                                            .reduce(
                                                (productAcc: any, productCurrent: any) =>
                                                    `${parseFloat(productCurrent.totalCost) +
                                                    parseFloat(productAcc)
                                                    }`,
                                                0
                                            ),
                                    });
                                    return acc;
                                }, [])
                                .map((item: any, groupIndex: any) => (
                                    <div
                                        style={{
                                            display: `${item.products.length !== 0 ? "inherit" : "none"
                                                }`,
                                        }}
                                        key={groupIndex}>
                                        <div className="row">
                                            <div className="col-sm-12 quote-product-header">
                                                <textarea
                                                    disabled={item.products.length !== 0}
                                                    name={`categoryName[${groupIndex}]`}
                                                    className="form-control"
                                                    placeholder="Header Name"
                                                    value={item.name}
                                                    ref={(x) =>
                                                        (this.categoryNameInputs[groupIndex] = x!)
                                                    }
                                                    data-index={groupIndex}
                                                    readOnly
                                                />
                                            </div>
                                        </div>

                                        {item.products.length !== 0 ? (
                                            <table
                                                className={`table table-responsive tblQuote mt-2 ${item.products.length == 0 && "hidden"
                                                    }`}
                                            >
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: "4%" }}>Quantity</th>
                                                        <th style={{ width: "4%" }}>UM</th>
                                                        <th style={{ width: "20%" }}>Item</th>
                                                        <th style={{ width: "20%" }}>Notes</th>
                                                        <th style={{ width: "10%" }}>Price</th>
                                                        <th style={{ width: "10%" }}>Amount</th>
                                                        <th style={{ width: "12%" }}>Cost</th>
                                                        <th style={{ width: "10%" }}>Total Cost</th>
                                                        <th style={{ width: "10%" }}></th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {item.products.map(
                                                        (item: any, productIndex: any) => (

                                                            item.isEditing ? (
                                                                <tr
                                                                    key={
                                                                        groupIndex +
                                                                        "," +
                                                                        productIndex
                                                                    }
                                                                    className="sortable-table-row quote-edit-product-row"
                                                                >
                                                                    <EditProductCostRow
                                                                        data={item}
                                                                        onClose={() =>
                                                                            this.handleEditCloseCostClicked(
                                                                                groupIndex,
                                                                                item.uniqueAutoId
                                                                            )
                                                                        }
                                                                        onSubmit={(e: any) =>
                                                                            this.handleEditCost(
                                                                                e,
                                                                                groupIndex,
                                                                                item.productId
                                                                            )
                                                                        }
                                                                    />
                                                                </tr>
                                                            ) : (
                                                                <tr
                                                                    key={
                                                                        groupIndex +
                                                                        "," +
                                                                        productIndex
                                                                    }
                                                                    className="sortable-table-row"
                                                                >
                                                                    <td style={{ width: "8%" }}>
                                                                        {item.quantity}
                                                                    </td>
                                                                    <td style={{ width: "4%" }}>
                                                                        {item.unitMeasurement}
                                                                    </td>
                                                                    <td style={{ width: "20%" }}>
                                                                        {item.productName}
                                                                    </td>
                                                                    <td style={{ width: "20%" }}>
                                                                        {item.notes}
                                                                    </td>
                                                                    <td
                                                                        className="text-right"
                                                                        style={{ width: "10%" }}
                                                                    >
                                                                        {numeral(item.price).format(
                                                                            "$0,0.00"
                                                                        )}
                                                                    </td>
                                                                    <td
                                                                        className="text-right"
                                                                        style={{ width: "10%" }}
                                                                    >
                                                                        {numeral(item.amount).format(
                                                                            "$0,0.00"
                                                                        )}
                                                                    </td>

                                                                    <td
                                                                        className={item.cost === 0 ? 'text-right zero-cost' : 'text-right'}
                                                                        style={{ width: "12%" }}
                                                                    >
                                                                        {numeral(item.cost).format(
                                                                            "$0,.00"
                                                                        )}
                                                                    </td>
                                                                    <td
                                                                        className={item.cost === 0 ? 'text-right zero-cost' : 'text-right'}
                                                                        style={{ width: "10%" }}
                                                                    >
                                                                        {numeral(
                                                                            item.totalCost
                                                                        ).format("$0,0.00")}
                                                                    </td>
                                                                    <td
                                                                        className="text-center"
                                                                        style={{ width: "10%" }}
                                                                    >
                                                                        <a
                                                                            href="#"
                                                                            className="btn-edit"
                                                                            onClick={(event) =>
                                                                                this.handleEditCostClicked(
                                                                                    event,
                                                                                    groupIndex,
                                                                                    item.productId
                                                                                )
                                                                            }
                                                                        >
                                                                            <i className="icon-edit1"></i>
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        )
                                                    )}
                                                </tbody>

                                                <tfoot>
                                                    <tr className="sub-total">
                                                        <td colSpan={4}>Subtotal</td>
                                                        <td colSpan={2} className="text-right">
                                                            {numeral(item.subTotal).format("$0,0.00")}
                                                        </td>
                                                        <td colSpan={2} className="text-right">
                                                            {numeral(item.subTotalCost).format(
                                                                "$0,0.00"
                                                            )}
                                                        </td>
                                                        <td colSpan={1}></td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        ) : null}
                                    </div>
                                ))}

                            <div className="button-actions text-center">
                                <button
                                    className="btn-link"
                                    onClick={(event) => this.handleSubmitPrevious(event, 2)}
                                >
                                    Previous
                                </button>
                                <div className="business-button-holder">
                                    <button
                                        className="btn btn-primary"
                                        onClick={(event) => this.handleSubmit(event, 4)}
                                        disabled={this.state.vendorId === 0}
                                    >
                                        Preview
                                    </button>
                                    <span>
                                        Note: The quote will also be saved as a Sales Order once
                                        sent to business Central
                                    </span>
                                </div>
                                <button className="btn-link" onClick={this.handleCancel}>
                                    Cancel
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }

    public componentDidMount() {

        let subTotal: number;
        let salesTax: number;
        let grandTotal: number;
        let subTotalCost: number;

        let dataset = this.props.data;

        this.setState({
            vendorId: Number(dataset.selectedVendorId),
            selectedVendorNo: dataset.selectedVendorNo,
            selectedVendorName: dataset.selectedVendorName,
        });
        let categories = this.props.data
            .productGroups as QuoteCostGroup<EditableQuoteProduct>[];

        if (categories.length === 0) {
            categories.push({
                name: "",
                products: [],
                subTotal: 0,
                subTotalCost: 0,
            });

            subTotal = 0;
            salesTax = 0;
            grandTotal = 0;
            subTotalCost = 0;
        } else {
            subTotal = categories.reduce(
                (total, category) => total + category.subTotal,
                0
            );
            salesTax =
                this.state.data.salesTaxRate != null
                    ? subTotal * this.props.data.salesTaxRate!
                    : 0;
            grandTotal = subTotal + salesTax;
            subTotalCost = categories.reduce(
                (total, category) => total + category.subTotalCost,
                0
            );
        }

        this.setState({
            costGroups: categories,
            subTotal: subTotal,
            salesTax: salesTax,
            grandTotal: grandTotal,
            subTotalCost: subTotalCost,
        });

    }

    public componentWillUpdate(nextProps: any) { }
    public componentDidUpdate(prev: any, prevState: any) {

        if (prev) {
            for (var i = 0; i < this.state.costGroups.length; i++) {
                this.categoryNameInputs[i].style.height = "0px";
                this.categoryNameInputs[i].style.height =
                    this.categoryNameInputs[i].scrollHeight + "px";
            }
        }

        if (JSON.stringify(prev.data) !== JSON.stringify(this.props.data)) {
        }

        let dataset = this.props.data;

    }

    static shouldComponentUpdate(nextProps: any, nextState: any) { }

    static getDerivedStateFromProps(props: any, state: any) { }
    private doNothing(e: React.FormEvent<HTMLAnchorElement>) {
        e.preventDefault();
    }

    private handleSubmit(
        event: React.MouseEvent<HTMLButtonElement> | any,
        nextStepNumber: number
    ) {
        event.preventDefault();

        let hasAllCosts = this.state.costGroups.every((costGroup) => {
            return costGroup.products.every((productCurrent) => {
                if (productCurrent.checked && productCurrent.cost === 0) {
                    return false;
                }
                return true;
            });
        });

        if (!hasAllCosts) {
            return;
        }

        let data = {
            categories: this.state.costGroups.reduce((acc: any, current: any) => {
                acc.push({
                    ...current,
                    products: current.products.reduce(
                        (productAcc: any, productCurrent: any) => {
                            if (productCurrent.checked) {
                                productAcc.push({
                                    ...productCurrent,
                                });
                            }
                            return productAcc;
                        },
                        []
                    ),
                    subTotal: current.products
                        .reduce((productAcc: any, productCurrent: any) => {
                            if (productCurrent.checked) {
                                productAcc.push({
                                    ...productCurrent,
                                });
                            }
                            return productAcc;
                        }, [])
                        .reduce(
                            (productAcc: any, productCurrent: any) =>
                                parseFloat(productCurrent.amount) + parseFloat(productAcc),
                            0
                        ),
                    subTotalCost: current.products
                        .reduce((productAcc: any, productCurrent: any) => {
                            if (productCurrent.checked) {
                                productAcc.push({
                                    ...productCurrent,
                                });
                            }
                            return productAcc;
                        }, [])
                        .reduce(
                            (productAcc: any, productCurrent: any) =>
                                parseFloat(productCurrent.totalCost) + parseFloat(productAcc),
                            0
                        ),
                });
                return acc;
            }, []),

            selectedVendorId: this.state.vendorId,
            selectedVendorNo: this.state.selectedVendorNo,
            selectedVendorName: this.state.selectedVendorName,
            nextStepNumber: nextStepNumber,
        };

        this.props.onSubmit(data);
    }

    private handleSubmitPrevious(
        event: React.MouseEvent<HTMLButtonElement> | any,
        nextStepNumber: number
    ) {
        event.preventDefault();

        let data = {
            categories: this.state.costGroups,
            selectedVendorId: this.state.vendorId,
            selectedVendorNo: this.state.selectedVendorNo,
            selectedVendorName: this.state.selectedVendorName,
            nextStepNumber: nextStepNumber,
        };
        this.props.onSubmit(data);
    }
    private handleSubmitAsDraft(event: React.MouseEvent<HTMLButtonElement>) {
        event.preventDefault();

        let data = {
            categories: this.state.costGroups,
            saveAsDraft: true,
        };

        for (let i = 0; i < this.categoryNameInputs.length; i++) {
            data.categories[i].name = this.categoryNameInputs[i].value;
        }

        this.props.onSubmit(data);
    }

    private handleCancel(event: React.MouseEvent<HTMLButtonElement>) {
        event.preventDefault();

        this.props.onCancel();
    }

    private handleAddCategoryClicked() {
        let categories = this.state.costGroups;
        categories.push({
            name: "",
            products: [],
            subTotal: 0,
            subTotalCost: 0,
        });
        this.setState({
            costGroups: categories,
        });
    }

    private handleAddCost(data: EditableQuoteProduct, groupIndex: number) {
        data.isEditing = false;
        let categories = this.state.costGroups;
        categories[groupIndex].products.push(data);
        categories[groupIndex].subTotal = categories[groupIndex].products.reduce(
            (total, product) => total + product.amount,
            0
        );
        categories[groupIndex].subTotalCost = categories[
            groupIndex
        ].products.reduce((total, product) => total + product.totalCost, 0);
        let subTotal = categories.reduce(
            (total, category) => total + category.subTotal,
            0
        );
        let salesTax =
            this.props.data.salesTaxRate !== undefined
                ? subTotal * this.props.data.salesTaxRate!
                : 0;
        let grandTotal = subTotal + salesTax;
        let subTotalCost = categories.reduce(
            (total, category) => total + category.subTotalCost,
            0
        );
        this.setState({
            costGroups: categories,
            subTotal: subTotal,
            salesTax: salesTax,
            grandTotal: grandTotal,
            subTotalCost: subTotalCost,
        });

    }

    private handleEditCostClicked(
        e: React.SyntheticEvent<HTMLAnchorElement>,
        groupIndex: number,
        productIndex: number
    ) {
        e.preventDefault();

        let categories = this.state.costGroups;

        const productCategoryIndex = categories[groupIndex].products.findIndex(
            (value) => value.productId === productIndex
        );
        categories[groupIndex].products[productCategoryIndex].isEditing = true;

        this.setState({
            costGroups: categories,
        });
    }

    private handleEditCloseCostClicked(groupIndex: number, productIndex: number) {
        let categories = this.state.costGroups;

        const productCategoryIndex = categories[groupIndex].products.findIndex(
            (value) => value.uniqueAutoId === productIndex
        );
        categories[groupIndex].products[productCategoryIndex].isEditing = false;

        this.setState({
            costGroups: categories,
        });
    }

    private handleEditCost(
        data: EditableQuoteProduct,
        groupIndex: number,
        productIndex: number
    ) {
        let categories = this.state.costGroups;

        const productCategoryIndex = categories[groupIndex].products.findIndex(
            (value) => value.productId === productIndex
        );
        categories[groupIndex].products[productCategoryIndex] = data;

        categories[groupIndex].subTotal = categories[groupIndex].products.reduce(
            (total, product) => total + product.amount,
            0
        );

        categories[groupIndex].subTotalCost = categories[
            groupIndex
        ].products.reduce((total, product) => total + product.totalCost, 0);

        let subTotal = categories.reduce(
            (total, category) => total + category.subTotal,
            0
        );

        let salesTax =
            this.props.data.salesTaxRate !== undefined
                ? subTotal * this.props.data.salesTaxRate!
                : 0;

        let grandTotal = subTotal + salesTax;
        let subTotalCost = categories.reduce(
            (total, category) => {
                return total + category.subTotalCost;
            },
            0
        );

        this.setState({
            costGroups: categories,
            subTotal: subTotal,
            salesTax: salesTax,
            grandTotal: grandTotal,
            subTotalCost: subTotalCost,
        }, () => {

        });
    }

    private handleRemoveCost(
        e: React.SyntheticEvent<HTMLAnchorElement>,
        groupIndex: number,
        productIndex: number
    ) {
        e.preventDefault();

        let categories = this.state.costGroups;
        categories[groupIndex].products.splice(productIndex, 1);
        categories[groupIndex].subTotal = categories[groupIndex].products.reduce(
            (total, product) => total + product.amount,
            0
        );
        categories[groupIndex].subTotalCost = categories[
            groupIndex
        ].products.reduce((total, product) => total + product.totalCost, 0);
        let subTotal = categories.reduce(
            (total, category) => total + category.subTotal,
            0
        );
        let salesTax =
            this.props.data.salesTaxRate !== undefined
                ? subTotal * this.props.data.salesTaxRate!
                : 0;
        let grandTotal = subTotal + salesTax;
        let subTotalCost = categories.reduce(
            (total, category) => total + category.subTotalCost,
            0
        );
        this.setState({
            costGroups: categories,
            subTotal: subTotal,
            salesTax: salesTax,
            grandTotal: grandTotal,
            subTotalCost: subTotalCost,
        });
    }

    private handleHeaderNameChanged(event: React.FormEvent<HTMLTextAreaElement>) {
        this.state.costGroups[
            parseInt(event.currentTarget.dataset.index!, 10)
        ].name = event.currentTarget.value;
        this.setState({
            costGroups: this.state.costGroups,
        });

        event.currentTarget.style.height = "0px";
        event.currentTarget.style.height = event.currentTarget.scrollHeight + "px";
    }

    private handleRemoveHeader(
        e: React.SyntheticEvent<HTMLAnchorElement>,
        groupIndex: number
    ) {
        e.preventDefault();

        const costGroups = this.state.costGroups;
        costGroups.splice(groupIndex, 1);
        this.categoryNameInputs.splice(groupIndex, 1);

        let subTotal: number;
        let salesTax: number;
        let grandTotal: number;
        let subTotalCost: number;

        if (costGroups.length === 0) {
            costGroups.push({
                name: "",
                products: [],
                subTotal: 0,
                subTotalCost: 0,
            });

            subTotal = 0;
            salesTax = 0;
            grandTotal = 0;
            subTotalCost = 0;
        } else {
            subTotal = costGroups.reduce((total, group) => total + group.subTotal, 0);
            salesTax =
                this.props.data.salesTaxRate !== undefined
                    ? subTotal * this.props.data.salesTaxRate!
                    : 0;
            grandTotal = subTotal + salesTax;
            subTotalCost = costGroups.reduce(
                (total, group) => total + group.subTotalCost,
                0
            );
        }

        this.setState({
            costGroups: costGroups,
            subTotal: subTotal,
            salesTax: salesTax,
            grandTotal: grandTotal,
            subTotalCost: subTotalCost,
        });

    }

    private handleDragEnd(result: any, provided: any) {
        if (!result.destination) {
            return;
        }

        if (result.draggableId.indexOf("header-") === 0) {
            if (result.source.droppableId === result.destination.droppableId) {
                return;
            }

            const sourceGroupIndex = parseInt(result.source.droppableId, 10);
            const destinationGroupIndex = parseInt(
                result.destination.droppableId,
                10
            );
            const costGroups = this.reorder(
                this.state.costGroups,
                sourceGroupIndex,
                destinationGroupIndex
            );
            this.setState({
                costGroups: costGroups,
            });
        } else if (result.draggableId.indexOf("product-") === 0) {
            if (result.source.droppableId === result.destination.droppableId) {
                // Reordering within the same list
                const groupIndex = parseInt(result.source.droppableId, 10);
                const products = this.reorder(
                    this.state.costGroups[groupIndex].products,
                    result.source.index,
                    result.destination.index
                );
                this.state.costGroups[groupIndex].products = products;
                this.setState({
                    costGroups: this.state.costGroups,
                });
            } else {
                // Item is being moved to a different list
                const sourceGroupIndex = parseInt(result.source.droppableId, 10);
                const destinationGroupIndex = parseInt(
                    result.destination.droppableId,
                    10
                );
                const newArrays = this.move(
                    this.state.costGroups[sourceGroupIndex].products,
                    result.source.index,
                    this.state.costGroups[destinationGroupIndex].products,
                    result.destination.index
                );

                this.state.costGroups[sourceGroupIndex].products = newArrays.source;
                this.state.costGroups[sourceGroupIndex].subTotal =
                    newArrays.source.reduce(
                        (total, product) => total + product.amount,
                        0
                    );
                this.state.costGroups[sourceGroupIndex].subTotalCost =
                    newArrays.source.reduce(
                        (total, product) => total + product.totalCost,
                        0
                    );
                this.state.costGroups[destinationGroupIndex].products =
                    newArrays.destination;
                this.state.costGroups[destinationGroupIndex].subTotal =
                    newArrays.destination.reduce(
                        (total, product) => total + product.amount,
                        0
                    );
                this.state.costGroups[destinationGroupIndex].subTotalCost =
                    newArrays.destination.reduce(
                        (total, product) => total + product.totalCost,
                        0
                    );
                this.setState({
                    costGroups: this.state.costGroups,
                });
            }
        }
    }

    private reorder<T>(list: T[], startIndex: number, endIndex: number) {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    }

    private move<T>(
        source: T[],
        sourceIndex: number,
        destination: T[],
        destinationIndex: number
    ) {
        const sourceClone = Array.from(source);
        const destClone = Array.from(destination);
        const [removed] = sourceClone.splice(sourceIndex, 1);

        destClone.splice(destinationIndex, 0, removed);

        return {
            source: sourceClone,
            destination: destClone,
        };
    }

    private handleVendorSelected(e: any) {
        let vendorName = e.target.value;
        this.setState({
            selectedVendorName: vendorName,
        });
    }
}

interface AddProductCostRowState extends QuoteProduct {
    maskedQuantity: string;
    maskedPrice: string;
    maskedCost: string;
}

interface EditProductCostRowProps {
    data: EditableQuoteProduct;
    onSubmit: Function;
    onClose: Function;
}

class EditProductCostRow extends React.Component<
    EditProductCostRowProps,
    AddProductCostRowState
> {
    private quantityInputRef: React.RefObject<HTMLInputElement>;
    private productSelectRef: React.RefObject<ProductSelect>;
    private notesInputRef: React.RefObject<HTMLTextAreaElement>;
    private priceInputRef: React.RefObject<MaskedInput>;
    private priceSelectRef: React.RefObject<PriceSelect>;

    public constructor(props: EditProductCostRowProps) {
        super(props);

        this.state = {
            productId: props.data.productId,
            uniqueAutoId: props.data.uniqueAutoId,
            maskedQuantity: props.data.quantity.toString(),
            quantity: props.data.quantity,
            unitMeasurement: props.data.unitMeasurement,
            productName: props.data.productName,
            notes: props.data.notes,
            price: props.data.price,
            unitPriceTypeId: props.data.unitPriceTypeId,
            maskedPrice: props.data.price.toString(),
            amount: props.data.amount,
            cost: props.data.cost === undefined ? null : (props.data.cost === 0 ? null : props.data.cost),
            maskedCost:
                props.data.cost === undefined ? "0" : (props.data.cost === null ? "0" : props.data.cost.toString()),
            totalCost: props.data.totalCost === undefined ? 0 : props.data.totalCost,
            testCost: ''
        };

        this.quantityInputRef = React.createRef();
        this.productSelectRef = React.createRef();
        this.notesInputRef = React.createRef();
        this.priceInputRef = React.createRef();
        this.priceSelectRef = React.createRef();

        this.handleInputChanged = this.handleInputChanged.bind(this);
        this.handleQuantityChanged = this.handleQuantityChanged.bind(this);
        this.handleProductSelect = this.handleProductSelect.bind(this);
        this.handleCostChanged = this.handleCostChanged.bind(this);
        this.handleQuantityOrCostChanged =
            this.handleQuantityOrCostChanged.bind(this);
        this.handleNotesChanged = this.handleNotesChanged.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
    }

    public render() {
        const numberMask = createNumberMask({
            prefix: '$',
            suffix: '',
            includeThousandsSeparator: true,
            thousandsSeparatorSymbol: ',',
            allowDecimal: true,
            decimalSymbol: '.',
            decimalLimit: 2, // how many digits allowed after the decimal
            integerLimit: 7, // limit length of integer numbers
            allowNegative: false,
            allowLeadingZeroes: false,
        });

        return (
            <>
                <td>{this.state.quantity}</td>
                <td>{this.state.unitMeasurement}</td>
                <td>{this.state.productName}</td>
                <td>
                    <textarea
                        name="notes"
                        className="form-control"
                        value={this.state.notes}
                        ref={this.notesInputRef}
                        onChange={this.handleNotesChanged}
                    />
                </td>

                <td>
                    {this.state.price !== undefined &&
                        numeral(this.state.price).format("$0,0")}
                </td>
                <td className="text-right">
                    {this.state.amount !== undefined &&
                        numeral(this.state.amount).format("$0,0")}
                </td>
                <td>
                    <input
                        type="number"
                        name="cost"
                        className="form-control"
                        autoComplete="off"
                        onChange={this.handleCostChanged}
                        onFocus={this.handleFocus}
                        value={this.state.cost !== undefined ? (this.state.cost !== null ? this.state.cost : '') : ''}

                    />

                </td>
                <td>
                    {this.state.totalCost !== undefined &&
                        numeral(this.state.totalCost).format("$0,0.00")}

                </td>
                <td>
                    <button
                        type="button"
                        className="form-control btn btn-primary"
                        onClick={this.handleSubmit}
                    >
                        Update
                    </button>

                    <button
                        type="button"
                        className="form-control btn btn-primary"
                        onClick={() => this.props.onClose()}
                    >
                        <i className="icon-close"></i>
                    </button>
                </td>
            </>
        );
    }

    public componentDidMount() {
        this.notesInputRef.current!.style.height = "0px";
        this.notesInputRef.current!.style.height =
            this.notesInputRef.current!.scrollHeight + "px";
    }

    public componentDidUpdate(
        prevProps: Readonly<EditProductCostRowProps>,
        prevState: Readonly<AddProductCostRowState>,
        snapshot?: any
    ): void { }

    private handleInputChanged(
        event: React.FormEvent<
            HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
        >
    ) {
        this.setState({
            [event.currentTarget.name]: event.currentTarget.value,
        } as any);
    }

    private handleQuantityChanged(event: React.FormEvent<HTMLInputElement>) {
        const maskedValue = event.currentTarget.value;
        const value = parseFloat(maskedValue) || 0;

        this.setState({
            quantity: value,
            maskedQuantity: maskedValue,
        });

        this.handleQuantityOrCostChanged();
    }


    private handleCostChanged(event: React.FormEvent<HTMLInputElement>) {
        const inputValue = event.currentTarget.value;

        if (inputValue === '') {
            this.setState({ cost: null, totalCost: 0 });
            return;
        }

        const numericValue = parseFloat(inputValue.replace(/[^0-9.]/g, ''));

        if (!isNaN(numericValue)) {
            const roundedValue = Math.round(numericValue * 100) / 100;

            this.setState({ cost: roundedValue }, () => {
                this.calculateTotalCost(roundedValue);
            });
        }
    };


    private calculateTotalCost = (cost: number): void => {
        this.setState((prevState) => {
            if (prevState) {
                return {
                    totalCost: (prevState.quantity || 0) * (cost || 0),
                };
            }
            return null;
        });
    };


    private handleFocus = (event: { target: { select: () => void; }; }) => {
        event.target.select();
    };

    private handleQuantityOrCostChanged() {
        this.setState((prevState) => ({
            totalCost: (prevState?.quantity ?? 0) * (prevState?.cost ?? 0),
        }));
    }

    private async handleProductSelect(value: Option | null) {
        if (value === null) {
            this.setState({
                productId: undefined,
                unitMeasurement: undefined,
                productName: undefined,
            });
        } else {
            this.setState({
                productId: value!.value as number,
                unitMeasurement: value!.unitMeasurement as string | undefined,
                productName: value!.label as string,
            });
        }
    }

    private handleNotesChanged(event: React.FormEvent<HTMLTextAreaElement>) {
        this.handleInputChanged(event);
        event.currentTarget.style.height = "0px";
        event.currentTarget.style.height = event.currentTarget.scrollHeight + "px";
    }

    private handleSubmit(event: React.MouseEvent<HTMLButtonElement> | any) {

        let data = {
            productId: this.state.productId,
            uniqueAutoId: this.state.uniqueAutoId,
            quantity: this.state.quantity,
            unitMeasurement: this.state.unitMeasurement,
            productName: this.state.productName,
            notes: this.state.notes,
            price: this.state.price,
            amount: this.state.amount,
            cost: this.state.cost === null ? 0 : this.state.cost,
            totalCost: this.state.totalCost,
            checked: true,
        };

        this.props.onSubmit(data);
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/quotes/SalesOrderStep3.tsx